export default __webpack_public_path__ + "static/media/13.42b3722f.jpg";